module.exports = __webpack_public_path__ + "img/용품.bb226e44.png";